import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { FileTextIcon, ArrowLeftIcon } from 'lucide-react';
import { CancellationAccordion } from '../components/policies/CancellationAccordion';
export function Cancellation() {
  return <>
      <Helmet data-id="element-1374">
        <title data-id="element-1375">Cancellation Policy | Bright Pixxel Studios</title>
        <meta name="description" content="Our Cancellation Policy explains refund windows, notice periods, and how we handle change requests." data-id="element-1376" />
      </Helmet>
      {/* Hero Section */}
      <section className="pt-16 md:pt-24 pb-12 bg-[#F9FAFB] dark:bg-[#121212]" data-id="element-1377">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1378">
          <div className="max-w-4xl mx-auto" data-id="element-1379">
            <Link to="/policies" className="inline-flex items-center text-[#0C1B26] hover:underline mb-6" data-id="element-1380">
              <ArrowLeftIcon size={16} className="mr-1" data-id="element-1381" />
              Back to Policies
            </Link>
            <div className="flex items-center mb-6" data-id="element-1382">
              <div className="w-12 h-12 rounded-full bg-[#0C1B26]/10 dark:bg-[#0C1B26]/20 flex items-center justify-center mr-4" data-id="element-1383">
                <FileTextIcon size={24} className="text-[#0C1B26]" data-id="element-1384" />
              </div>
              <motion.h1 initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              duration: 0.5
            }} className="text-3xl md:text-4xl font-bold" data-id="element-1385">
                Cancellation Policy
              </motion.h1>
            </div>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="text-lg text-gray-600 dark:text-gray-300 mb-4" data-id="element-1386">
              Last Updated: May 1, 2023
            </motion.p>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="text-lg text-gray-600 dark:text-gray-300" data-id="element-1387">
              This Cancellation Policy outlines the terms and conditions
              regarding cancellations, refunds, and changes to projects and
              services provided by Bright Pixxel Studios ("we", "us", "our"). By
              engaging our services, you agree to the terms set forth in this
              policy.
            </motion.p>
          </div>
        </div>
      </section>
      {/* Policy Content */}
      <section className="py-12 bg-white dark:bg-[#1E1E1E]" data-id="element-1388">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1389">
          <div className="max-w-4xl mx-auto" data-id="element-1390">
            <CancellationAccordion data-id="element-1391" />
          </div>
        </div>
      </section>
    </>;
}